export default __webpack_public_path__ + "static/media/ico-planteo-dollar.9f795e51.svg";